const formatNumber = ({ num, isInt, isTruncated, }) => {
    if (typeof num === 'number') {
        num = num.toString();
    }
    if (isInt) {
        num = Number(parseFloat(num).toFixed(0));
    }
    else {
        num = Number(parseFloat(num).toFixed(3));
    }
    if (isTruncated) {
        if (num >= 1000000) {
            return `${intlFormat(num / 1000000)} M`;
        }
        if (num >= 1000) {
            return `${intlFormat(num / 1000)} K`;
        }
    }
    return intlFormat(num);
};
const intlFormat = (num) => {
    if (num > 1) {
        return new Intl.NumberFormat().format(Math.round(num * 10) / 10);
    }
    return num;
};
const removeNumFormat = (val) => {
    // Remove commas and any non-numeric characters except for the last character if it is 'k', 'm', or 'b'.
    const cleanedVal = val.replace(/[^0-9.kmb]+/gi, '');
    let returnVal;
    const multiplier = cleanedVal.substr(-1).toLowerCase();
    if (multiplier === 'k') {
        returnVal = parseFloat(cleanedVal) * 1000;
    }
    else if (multiplier === 'm') {
        returnVal = parseFloat(cleanedVal) * 1000000;
    }
    else if (multiplier === 'b') {
        returnVal = parseFloat(cleanedVal) * 1000000000;
    }
    else {
        returnVal = parseFloat(cleanedVal);
    }
    return returnVal;
};
const calculatePercentageChange = ({ oldValue, newValue }) => {
    if (oldValue > 0) {
        return ((newValue - oldValue) / oldValue) * 100;
    }
    return null;
};
const checkAndFormatNumber = (value) => {
    return isNaN(Number(value)) ? 0 : Number(value);
};
export { formatNumber, intlFormat, removeNumFormat, calculatePercentageChange, checkAndFormatNumber };
